import { ICollectionProducts } from "../interfaces/shopify";
import { client } from "./shopifyClient";

export const getSearchProducts = async (
  searchTitle = ""
): Promise<ICollectionProducts> => {
  const query = `
  {
    products(
      first:6,
      ${searchTitle ? `query: "title:*${searchTitle}*"` : ""}
    ) {
      edges {
        node {
          id
          handle
          title
          description
          tags
          images(first: 1) {
            edges {
              node {
                url
                altText
              }
            }
          }
          variants(first: 1) {
            edges {
              node {
                price {
                  amount
                  currencyCode
                }
                compareAtPrice {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    }
  }
  `;

  const response = await client.request(query);

  const products =
    response?.data?.products?.edges?.map((edge: any) => edge.node) ?? [];

  const parentProducts = products.filter((p: any) =>
    p.tags?.includes("shsdparentproduct")
  );

  return {
    categoryTitle: "Search Results",
    products: parentProducts,
    banner: null,
  };
};
